module.exports = __webpack_public_path__ + "33b225b35eef86565fd101fbd55b2ff4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/talking-s.png
// module id = 1792
// module chunks = 0